export default __webpack_public_path__ + "static/media/mechelen-katelijne.a97ed4ad.jpg";